import dayjs from 'dayjs';

export const isPastOffsetHours = (date: Date, hours: number) => {
  const currentDate = dayjs();
  const expirationDate = dayjs(date).add(hours, 'hours');

  console.log('isPastOffsetHours Received parameters', date, hours);
  console.log('isPastOffsetHours', currentDate, expirationDate);
  if (currentDate.isAfter(expirationDate)) {
    console.log('isPastOffsetHours', currentDate, expirationDate);
    return true;
  }

  return false;
};

export const getDate = () => {
  return dayjs();
};

export const isStartOfMonth = (date: Date) => {
  if (!date) return true;

  const lastFreeTopup = dayjs(date);
  return lastFreeTopup.month() !== dayjs().month();
};

export const isDateWithinToday = (date?: Date) => {
  if (!date) return false;
  return dayjs(date).isSame(dayjs(), 'day');
};

export const isSameDay = (
  date1: string | Date,
  date2: string | Date,
): boolean => {
  const givenDate1 = dayjs(date1);
  const givenDate2 = dayjs(date2);

  return givenDate1.isSame(givenDate2, 'day');
};
